import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Field } from "react-final-form";
import Libelle from "../../../../../../_i18n/fr.json";
import FormContainer from "../../../../../../components/FormContainer/index";
import InputField from "../../../../../../components/input/InputField";
import InputCalendrier from "../../../../../../components/inputCalendrier/InputCalendrier";
import InputCheckbox from "../../../../../../components/inputCheckbox/InputCheckbox";
import Select from "../../../../../../components/select/Select";
import {
  calculSalaireNetMensuel,
  maskNumSiret,
  showMonth,
} from "../../../../../../helpers/formatters";
import cumulAnnee from "../../../../../../ressources/images/cum_impo_m1.png";
import salaireMois from "../../../../../../ressources/images/net_impo_m1.png";
import { SituationProfessionnelle } from "../../../../../../services/Api/swagger/api";
import {
  construireSituationsProfessionnelles,
  construireStatutsProfessionnels,
  getConditionsAffichage,
  getId,
  ISituationProfessionnellePresentation,
} from "../../../helpers";
import * as Messages from "../../../messages";
import {
  addDays,
  addYears,
  endOfDay,
  endOfMonth,
  startOfMonth,
  subMonths,
} from "date-fns";

interface Props {
  situationsPros?: SituationProfessionnelle[];
  formValues?: ISituationProfessionnellePresentation;

  change(field: string, value: any): any;

  prefixe: "principal" | "secondaire";
  classes?: any;
  isCumulsUtilises: boolean;
}

function SituationProfessionnelleUnePersonne({
  situationsPros,
  formValues,
  change,
  prefixe,
  isCumulsUtilises,
}: Props) {
  const [statutsProOptions, setStatutsProOptions] = useState<
    | {
        key: string | undefined;
        text: string | undefined;
        value: string | undefined;
      }[]
    | undefined
  >([]);
  const [selectedSituation, setSelectedSituation] =
    useState<SituationProfessionnelle | undefined>();

  const onChangeSituation = (situation: string) => {
    const selectedSituation: SituationProfessionnelle | undefined =
      situationsPros && situationsPros.find((s) => s.code === situation);
    const statutsOptions =
      selectedSituation &&
      selectedSituation.statutsProfessionnels &&
      construireStatutsProfessionnels(selectedSituation.statutsProfessionnels);
    setStatutsProOptions(statutsOptions);
    setSelectedSituation(selectedSituation);
    nbrMoisTravaillesListener();
     const statutExist = selectedSituation?.statutsProfessionnels?.find(
        (s) => s.code === formValues?.codeStatutProfessionnel
      );
      if (!statutExist) {
        const statut =
          selectedSituation?.statutsProfessionnels &&
          selectedSituation?.statutsProfessionnels[0] &&
          selectedSituation?.statutsProfessionnels[0].code;
        change(getId(prefixe, "codeStatutProfessionnel"), statut);
      }
  };

  useEffect(() => {
    if (formValues?.situation) {
      onChangeSituation(formValues.situation);
    }
  }, [formValues?.situation]);

  useEffect(() => {
    if (formValues?.salaireBrutMensuel) {
      const salaireNet = calculSalaireNetMensuel(
        formValues?.salaireBrutMensuel,
        formValues.situation
      );
      change(getId(prefixe, "salaireNetMensuel"), salaireNet);
    } else {
      change(getId(prefixe, "salaireNetMensuel"), undefined);
    }
  }, [formValues?.salaireBrutMensuel, formValues?.situation]);
  // useEffect(() => {
  //   if (formValues?.situation && selectedSituation) {
     
  //   }
  // }, [selectedSituation, formValues?.situation]);

  const {
    isSalarie,
    isNonSalarie,
    isDateDebutStartAt30jDateJour,
    isDateActiviteAvant45j,
    isDateActiviteAvant75j,
    isDateActiviteAvant105j,
    isDateDebutActivitePlus1an,
    isNonSalarieOrAutre,
    isCdiEssaiOrCddOrInterimaire,
    isEtudiantOuSansActivite,
    canSeeNombreMoisTravaille,
  } = getConditionsAffichage(formValues);
  const nbrMoisTravaillesListener = () => {
    if (formValues && !isDateActiviteAvant45j) {
      change(getId(prefixe, "salaireNetImposableM1"), undefined);
      change(getId(prefixe, "cumulSalaireNetImposableM1"), undefined);
    }
    if (formValues && !isDateActiviteAvant75j) {
      change(getId(prefixe, "salaireNetImposableM2"), undefined);
      change(getId(prefixe, "cumulSalaireNetImposableM2"), undefined);
    }
    if (formValues && !isDateActiviteAvant105j) {
      change(getId(prefixe, "salaireNetImposableM3"), undefined);
      change(getId(prefixe, "cumulSalaireNetImposableM3"), undefined);
    }
  };

  useEffect(() => {
    if (isDateDebutStartAt30jDateJour) {
      change(getId(prefixe, "salaireBrutMensuel"), undefined);
      change(getId(prefixe, "salaireNetMensuel"), undefined);
    }
    if (!isDateDebutStartAt30jDateJour) {
      change(getId(prefixe, "salaireNetImposableM1"), undefined);
      change(getId(prefixe, "cumulSalaireNetImposableM1"), undefined);
      change(getId(prefixe, "salaireNetImposableM2"), undefined);
      change(getId(prefixe, "cumulSalaireNetImposableM2"), undefined);
      change(getId(prefixe, "salaireNetImposableM3"), undefined);
      change(getId(prefixe, "cumulSalaireNetImposableM3"), undefined);
      change(getId(prefixe, "cumulSalaireNetImposableM3"), undefined);
      change(getId(prefixe, "dateDernierBulletin"), undefined);
    }
  }, [isDateDebutStartAt30jDateJour]);
  const situationsProOptions =
    situationsPros && construireSituationsProfessionnelles(situationsPros);

  const limitInfDateFinSituation =
    formValues?.dateDebutSituationProfessionnelle &&
    addDays(formValues.dateDebutSituationProfessionnelle, 1);

  let titleDerniersMois = "";
  if (isDateActiviteAvant105j) {
    titleDerniersMois = Libelle.pageSituationPro.sections.sousSectionMois3;
  } else if (isDateActiviteAvant75j) {
    titleDerniersMois = Libelle.pageSituationPro.sections.sousSectionMois2;
  } else if (isDateActiviteAvant45j) {
    titleDerniersMois = Libelle.pageSituationPro.sections.sousSectionMois1;
  }

  return (
    <>
      <FormContainer>
        <>
          <h4>{Libelle.pageSituationPro.sections.sousSection1}</h4>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Field
                name={getId(prefixe, "situation")}
                component={Select}
                options={situationsProOptions}
                label="Situation"
                onChange={onChangeSituation}
                required
              />
            </Grid>
            {(isSalarie || isNonSalarieOrAutre) && (
              <Grid item>
                <Field
                  name={getId(prefixe, "codeStatutProfessionnel")}
                  component={Select}
                  options={statutsProOptions}
                  label="Statut"
                  required
                />
              </Grid>
            )}

            {/* addDays(endOfDays(new Date()), 60) */}
            <Grid item>
              <Field
                name={getId(prefixe, "dateDebutSituationProfessionnelle")}
                component={InputCalendrier}
                maxDate={
                  formValues?.situation === "ETU"
                    ? endOfDay(new Date(new Date().getFullYear(), 11, 31))
                    : addDays(endOfDay(new Date()), 60)
                }
                label="Date de début"
                required
                variante="inline"
                varianteInput="filled"
                onChange={nbrMoisTravaillesListener}
                minDateMessage={Messages.default.maxDateMessage}
                maxDateMessage={Messages.default.minDateMessage}
                invalidDateMessage={Messages.default.invalidDateMessage}
              />
            </Grid>
            {isCdiEssaiOrCddOrInterimaire && (
              <Grid item>
                <Field
                  name={getId(prefixe, "dateFinSituationProfessionnelle")}
                  component={InputCalendrier}
                  maxDate={addYears(endOfMonth(new Date()), 5)}
                  minDate={limitInfDateFinSituation}
                  label="Date de fin"
                  required
                  variante="inline"
                  varianteInput="filled"
                  minDateMessage={Messages.default.maxDateMessage}
                  invalidDateMessage={Messages.default.invalidDateMessage}
                />
              </Grid>
            )}
          </Grid>
          <Grid container spacing={2}>
            {canSeeNombreMoisTravaille && (
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "nombreMoisTravailles")}
                  component={InputField}
                  label="Nombre de mois travaillés"
                  type="number"
                  required
                  maxLength={2}
                  note="(sur les 24 derniers mois, tous emplois confondus)"
                  classNote={"classNoteBold"}
                  numberAfterDecimal={0}
                />
              </Grid>
            )}
            {/* subMonths(startOfMonth(new Date()), 2) */}
            {isSalarie && isDateDebutStartAt30jDateJour && (
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "dateDernierBulletin")}
                  component={InputCalendrier}
                  isYearMonth={true}
                  minDate={subMonths(startOfMonth(new Date()), 2)}
                  maxDate={endOfMonth(new Date())}
                  label="Dernier bulletin de salaire"
                  required
                  variante="inline"
                  varianteInput="filled"
                  onChange={"nbrMoisTravaillesListener"}
                  minDateMessage={
                    Messages.default.maxDatedernierBulletinMessage
                  }
                  maxDateMessage={
                    Messages.default.minDatedernierBulletinMessage
                  }
                  invalidDateMessage={Messages.default.invalidDateMessage}
                />
              </Grid>
            )}
            {formValues &&
              (formValues.situation === "SPR" ||
                formValues.situation === "TNS") && (
                <Grid item xs={3}>
                  <Field
                    name={getId(prefixe, "codeApe")}
                    component={InputField}
                    maxLength={5}
                    label="Code APE (NAF)"
                    type="text"
                    required
                  />
                </Grid>
              )}

            {isNonSalarie && (
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "siret")}
                  component={InputField}
                  mask={maskNumSiret()}
                  label="SIRET"
                  type="text"
                  required
                />
              </Grid>
            )}
          </Grid>
          {!isEtudiantOuSansActivite && (
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "pasAvisImposition")}
                  component={InputCheckbox}
                  label="Ne possède pas d’avis d’imposition"
                />
                <Typography
                  className={"classNoteBold"}
                  variant="caption"
                  dangerouslySetInnerHTML={{
                    __html:
                      "(toute personne de plus de 26 ans a un avis d’imposition ou de non-imposition)",
                  }}
                />
              </Grid>
            </Grid>
          )}
          {/* tslint:disable-next-line:max-line-length */}
          {/*<MessageInfo messageUrl="Attention, la modification de certains champs peut provoquer la suppression des pièces justificatives concernées." />*/}
        </>
      </FormContainer>
      {isSalarie && isDateActiviteAvant45j && (
        <FormContainer>
          <h4>{titleDerniersMois}</h4>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <Field
                name={getId(prefixe, "salaireNetImposableM1")}
                component={InputField}
                label={
                  formValues &&
                  "Salaire net imposable " +
                    showMonth(formValues.dateDernierBulletin)
                }
                type="number"
                max={99999}
                required
                numberAfterDecimal={0}
                imageHelpInfo={salaireMois}
              />
            </Grid>
            {isCumulsUtilises && isDateDebutActivitePlus1an && (
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "cumulSalaireNetImposableM1")}
                  component={InputField}
                  label={
                    formValues &&
                    formValues.dateDernierBulletin &&
                    "Cumul salaire net imposable " +
                      showMonth(formValues.dateDernierBulletin)
                  }
                  type="number"
                  max={999999}
                  required
                  numberAfterDecimal={0}
                  imageHelpInfo={cumulAnnee}
                />
              </Grid>
            )}
          </Grid>
          {isDateActiviteAvant75j && (
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "salaireNetImposableM2")}
                  component={InputField}
                  label={
                    formValues &&
                    formValues.dateDernierBulletin &&
                    "Salaire net imposable " +
                      showMonth(subMonths(formValues.dateDernierBulletin, 1))
                  }
                  type="number"
                  max={99999}
                  numberAfterDecimal={0}
                  required
                />
              </Grid>
              {isCumulsUtilises && isDateDebutActivitePlus1an && (
                <Grid item xs={3}>
                  <Field
                    name={getId(prefixe, "cumulSalaireNetImposableM2")}
                    component={InputField}
                    label={
                      formValues &&
                      formValues.dateDernierBulletin &&
                      "Cumul salaire net imposable " +
                        showMonth(subMonths(formValues.dateDernierBulletin, 1))
                    }
                    type="number"
                    max={999999}
                    numberAfterDecimal={0}
                    required
                  />
                </Grid>
              )}
            </Grid>
          )}
          {isDateActiviteAvant105j && (
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "salaireNetImposableM3")}
                  component={InputField}
                  label={
                    formValues &&
                    formValues.dateDernierBulletin &&
                    "Salaire net imposable " +
                      showMonth(subMonths(formValues.dateDernierBulletin, 2))
                  }
                  type="number"
                  max={99999}
                  numberAfterDecimal={0}
                  required
                />
              </Grid>
              {isCumulsUtilises && isDateDebutActivitePlus1an && (
                <Grid item xs={3}>
                  <Field
                    name={getId(prefixe, "cumulSalaireNetImposableM3")}
                    component={InputField}
                    label={
                      formValues &&
                      formValues.dateDernierBulletin &&
                      "Cumul salaire net imposable " +
                        showMonth(subMonths(formValues.dateDernierBulletin, 2))
                    }
                    type="number"
                    max={999999}
                    numberAfterDecimal={0}
                    required
                  />
                </Grid>
              )}
            </Grid>
          )}
        </FormContainer>
      )}
      {isSalarie &&
        formValues?.dateDebutSituationProfessionnelle &&
        !isDateDebutStartAt30jDateJour && (
          <FormContainer>
            <h4>{Libelle.pageSituationPro.sections.revenuMensuel}</h4>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "salaireBrutMensuel")}
                  component={InputField}
                  label={"Salaire brut mensuel"}
                  type="number"
                  max={99999}
                  required
                  note="Diviser par 12 le salaire brut annuel"
                  numberAfterDecimal={0}
                />
              </Grid>
              <Grid item xs={3}>
                <Field
                  name={getId(prefixe, "salaireNetMensuel")}
                  component={InputField}
                  label={"Salaire net mensuel"}
                  type="number"
                  disabled
                />
              </Grid>
            </Grid>
          </FormContainer>
        )}
    </>
  );
}

export default SituationProfessionnelleUnePersonne;
